import NameLinkCell from '@/components/NameLinkCell';
import type { Org } from '@/types';
import React, { type FC, memo } from 'react';

import styles from '../styles.module.css';

const OrgNameCell: FC<{ data: Org }> = ({ data }) => (
  <NameLinkCell
    className={styles.nameBtn}
    from="/organizations/"
    fullHeight
    id={data.id}
    name={data.name}
    params={{ orgId: data.id }}
    testId={`details-btn-${data.id}`}
    to="/organizations/$orgId"
  />
);

export default memo(OrgNameCell);
